import Vue from "vue";
import {Button} from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';

Vue.use(Button)
